import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Ruler } from "lucide-react";

export function UnitSelectModal({ open, onOpenChange, onSelect, fileName }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[#6A7359] flex items-center gap-2">
            <Ruler className="w-5 h-5" />
            Select Unit of Measurement
          </DialogTitle>
          <DialogDescription>
            What unit are the dimensions in <strong>{fileName}</strong>?
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-3 gap-3 mt-4">
          <Button 
            variant="outline" 
            onClick={() => onSelect("inches")}
            className="flex flex-col h-20 border-[#6A7359] hover:bg-[#6A7359]/10"
            data-testid="unit-inches"
          >
            <span className="text-lg font-semibold">Inches</span>
            <span className="text-xs text-gray-500">e.g. 12", 15-7/16"</span>
          </Button>
          <Button 
            variant="outline" 
            onClick={() => onSelect("cm")}
            className="flex flex-col h-20 border-[#6A7359] hover:bg-[#6A7359]/10"
            data-testid="unit-cm"
          >
            <span className="text-lg font-semibold">CM</span>
            <span className="text-xs text-gray-500">Centimeters</span>
          </Button>
          <Button 
            variant="outline" 
            onClick={() => onSelect("mm")}
            className="flex flex-col h-20 border-[#6A7359] hover:bg-[#6A7359]/10"
            data-testid="unit-mm"
          >
            <span className="text-lg font-semibold">MM</span>
            <span className="text-xs text-gray-500">Millimeters</span>
          </Button>
        </div>
        <p className="text-xs text-gray-500 text-center mt-3">
          This helps us accurately calculate your quote
        </p>
      </DialogContent>
    </Dialog>
  );
}
